
(() => {
  const normalize = (text) =>
    String(text || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();

  function selectedColor(picker) {
    const groups = picker.querySelectorAll('.product-form__input');

    for (const group of groups) {
      const label = group.querySelector('.form__label');
      if (!label || !['color', 'colour'].includes(normalize(label.textContent))) {
        continue;
      }

      const selected = group.querySelector('input:checked, select');
      return selected?.value || null;
    }

    return null;
  }

  function mediaColor(element) {
    const alt = element.querySelector('img[alt]')?.getAttribute('alt') || '';
    const match = alt.match(/color:\s*([^|,;]+)/i);
    return match ? normalize(match[1]) : null;
  }

  function filterGallery(picker) {
    const color = normalize(selectedColor(picker));
    const section = picker.dataset.section;
    const gallery = document.getElementById(`MediaGallery-${section}`);

    if (!color || !gallery) return;

    const slides = [...gallery.querySelectorAll(
      `[id^="Slide-${section}-"][data-media-id]`
    )];

    const thumbnails = [...gallery.querySelectorAll(
      `[id^="Slide-Thumbnails-${section}-"][data-target]`
    )];

    const tagged = slides.filter((slide) => mediaColor(slide));

    if (!tagged.length) return;

    const matching = tagged.filter(
      (slide) => mediaColor(slide) === color
    );

    if (!matching.length) return;

    const visibleIds = new Set(
      matching.map((slide) => slide.dataset.mediaId)
    );

    slides.forEach((slide) => {
      slide.style.display = visibleIds.has(slide.dataset.mediaId)
        ? ''
        : 'none';
    });

    thumbnails.forEach((thumb) => {
      const target = thumb.dataset.target;
      const visible = [...visibleIds].some(
        (id) => target === id || target.endsWith(`-${id}`)
      );

      thumb.style.display = visible ? '' : 'none';
    });

    const first = matching[0];

    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(first.dataset.mediaId, false);
    }
  }

  function refresh() {
    document.querySelectorAll('variant-selects').forEach(filterGallery);
  }

  document.addEventListener('DOMContentLoaded', refresh);

  document.addEventListener('change', (event) => {
    const picker = event.target.closest('variant-selects');
    if (picker) {
      setTimeout(() => filterGallery(picker), 150);
    }
  });
})();
